import { FormInputProps } from '../../types'
import { FieldPropertyMention } from '../../../FieldPropertyMention'
import { CustomSelect } from '../../../CustomSelect'

export function OptionsTextFormInput (props: FormInputProps) {
  return (
    <>
      {props.schema.options && props.value?.type !== 'template' && (
        <CustomSelect
          onChange={value => {
            props.onChange(
              value
                ? { type: 'text', text: { value } }
                : undefined
            )
          }}
          value={
            (props.value?.type === 'text' && !Array.isArray(props.value.text.value) && props.value.text.value) || ''
          }
          options={[
            { label: 'Select an option', value: '' },
            ...props.schema.options
          ]}
          showOptionValues={true}
        />
      )}

      {props.value?.type === 'template' && (
        <FieldPropertyMention
          value={props.value?.type === 'template' ? props.value.template : undefined}
          onChange={value => props.onChange({ type: 'template', template: value })}
          fields={props.fields ?? []}
        />
      )}
    </>
  )
}
